export default __webpack_public_path__ + "static/media/word.f3c7c2ad.svg";